import { EventAggregator } from '@src/infrastructure/eventAggregator';

export type ToastType = 'Success' | 'Info' | 'Error';

export class Toast {
    public message = ko.observable('');
    public headerIconClass: KnockoutComputed<string>;
    public headerBackgroundColorClass: KnockoutComputed<string>
    public id: string;
    public duplicateCount = ko.observable('');
    public duplicateCountClass = ko.observable('');

    constructor(
        public uniqueId: number,
        private eventAggregator: EventAggregator,
        private toastType: ToastType,
        message: string) {
        this.message(message);
        this.headerIconClass = ko.pureComputed(this.headerIconClassHandler, this);
        this.headerBackgroundColorClass = ko.pureComputed(this.headerBackgroundColorClassHandler, this);
        this.id = `toast-${uniqueId}`;
    }

    show() {
        let scoppedEventAggregator = this.eventAggregator;
        let scoppedToastObject = this;
        let display: any;

        display = { autohide: false };

        $(`#${this.id}`)
            .toast(display)
            .toast('show');
        //Invoke the CloseClicked method to make sure the toast object is removed from the array.
        $(`#${this.id}`).on('hidden.bs.toast', function () {
            scoppedEventAggregator.publish('CloseClicked', scoppedToastObject);
        });
    }

    close() {
        $(`#${this.id}`).toast('hide');
        this.eventAggregator.publish('CloseClicked', this);
    }

    headerIconClassHandler() {
        switch (this.toastType) {
            case 'Info':
                return 'fa-question-circle';
            case 'Success':
                return 'fa-check-circle';
            case 'Error':
                return 'fa-info-circle';
        }
    }

    headerBackgroundColorClassHandler() {
        switch (this.toastType) {
            case 'Info':
                return 'bg-info';
            case 'Success':
                return 'bg-success';
            case 'Error':
                return 'bg-danger';
        }
    }
}